module.exports = __webpack_public_path__ + "fff3cf8a5f07fa24eec027a1f914808a.png";